// extracted by mini-css-extract-plugin
export var addToCartButton = "_p5-b";
export var arrowButtonContainer = "_p5-9";
export var arrowButtonIcon = "_p5-a";
export var carouselArrowButton = "_p5-6";
export var carouselElementContainer = "_p5-1";
export var galleryThumbnail = "_p5-d";
export var galleryThumbnailImage = "_p5-e";
export var left = "_p5-7";
export var productDisplayCarouselContainer = "_p5-0";
export var productTileContainer = "_p5-2";
export var productTileImage = "_p5-4";
export var productTileImageContainer = "_p5-3";
export var productTileTitle = "_p5-5";
export var right = "_p5-8";
export var sliderOverflow = "_p5-c";